export function formatTwoDecimals(num) {
  if (num) {
    return parseFloat(num.toFixed(2));
  }
  return 0;
}
